import React from 'react';
import PropTypes from 'prop-types';
import ReviewCard from './ReviewCard';
import bellIcon from '../../../assets/images/bell-icon.svg';
import './ReviewIndexPage.scss';
var renderMultipleReviewCards = function renderMultipleReviewCards(reviews) {
  return reviews.map(function (review) {
    return /*#__PURE__*/React.createElement(ReviewCard, {
      key: review.project_resource_id,
      resourceId: review.resource_id,
      projectResourceId: review.project_resource_id,
      name: review.consultant_name,
      projectName: review.project_name,
      reviewed: review.resource_id !== null,
      rate: review.hourly_rate
    });
  });
};
function ReviewIndexPage(_ref) {
  var reviews = _ref.reviews;
  return /*#__PURE__*/React.createElement("div", {
    className: "style-guide dashboard-body-background"
  }, /*#__PURE__*/React.createElement("div", {
    className: "multi-review-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("img", {
    src: bellIcon,
    alt: "review-alert-icon"
  }), reviews.length, ' ', "Pending Consultant Review(s)"), /*#__PURE__*/React.createElement("p", null, "Leave feedback on your experience working with these consultants."), /*#__PURE__*/React.createElement("p", null, "You'll be able to give private feedback, just for Clora, and a public review to help future hiring managers.")), /*#__PURE__*/React.createElement("div", {
    className: "cards mb-3"
  }, renderMultipleReviewCards(reviews))));
}
ReviewIndexPage.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default ReviewIndexPage;